const HIGHEST_PRIORITY = 100;
const NONE = undefined;

export const PatientHealthEventSortOrderType = {
  HIGHEST_PRIORITY,
  NONE,
};
